import styled from "styled-components";

export const Card = styled.div`
  width: 31%;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 6.4rem;
  &:nth-of-type(5),
  &:nth-of-type(4),
  &:nth-of-type(6) {
    margin-bottom: 0;
  }
  p {
    text-align: center;
  }
  @media (max-width: 600px) {
    margin-bottom: 2.4rem;
  }
  @media (max-width: 768px) {
    width: 45%;
  }
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const CardImg = styled.div`
  width: 100%;
  /* height: 60px; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2.4rem;
  /* margin-bottom: 3.5rem; */
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin-top: 0.8rem;
  margin-bottom: 2.4rem;

  @media (max-width: 1024px) {
    width: ${(props) => props.width1024 || "100%"};
    height: ${(props) => props.height1024 || "100%"};
  }
  @media (max-width: 480px) {
    margin-bottom: 0;
  }
  p {
    font-weight: 700;
    font-family: Peyda;
    font-size: 1.8rem;
    line-height: 3.6rem;
    color: var(--small-text-color);
    /* @media (max-width: 768px) {
      font-size: 1.4rem;
      line-height: 2rem;
    } */
  }
`;
